import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import React from 'react';
import { ILegalRole } from '../../../Interfaces/ILegalRole';
import { ILegalRole_canInvite } from '../../../Interfaces/ILegalRole_canInvite';
import { LegalRoleCanInviteRow } from './LegalRoleCanInviteRow';

interface IProps {
  legalRoles: ILegalRole[];
  legalRoleCanInviteMap: ILegalRole_canInvite[];
  setLegalRoleCanInviteMap: React.Dispatch<
    React.SetStateAction<ILegalRole_canInvite[]>
  >;
}

export const LegalRoleCanInviteTable: React.FC<IProps> = ({
  legalRoles,
  legalRoleCanInviteMap,
  setLegalRoleCanInviteMap,
}) => {
  const contextTsx = () => {
    const filteredRoles = legalRoles.filter(x => Boolean(x.canInvite));

    if (filteredRoles.length === 0) {
      return (
        <>
          <i>Keine Rollen mit Einladeerlaubnis vorhanden.</i>
        </>
      );
    } else {
      return (
        <>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Rolle</TableCell>
                <TableCell>Darf Zuweisen</TableCell>
                <TableCell sx={{ width: 100 }}>Aktionen</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {filteredRoles.map(x => (
                <LegalRoleCanInviteRow
                  key={`idLegalRole-${x.idLegalRole}`}
                  legalRoleObject={x}
                  legalRoles={legalRoles}
                  legalRoleCanInviteMap={legalRoleCanInviteMap}
                  setLegalRoleCanInviteMap={setLegalRoleCanInviteMap}
                />
              ))}
            </TableBody>
          </Table>
        </>
      );
    }
  };

  return (
    <>
      <Typography variant='h6' sx={{ mt: 5 }}>
        Einladerelationen
      </Typography>
      <br />

      {contextTsx()}
    </>
  );
};
